import React from "react";
import clsx from "clsx";

/**
 * Row of quick-filter tiles above the task list.
 *
 * tiles: [{ id, label, value, meta, tone, active, onClick }]
 */
const TaskStats = ({ tiles }) => {
	if (!tiles || tiles.length === 0) {
		return null;
	}

	return (
		<div className="task-stats">
			{tiles.map(tile => (
				<button
					type="button"
					key={tile.id}
					className={clsx("task-stat", `task-stat--${tile.tone}`, `ft-task-stat-${tile.id}`, { "task-stat--on": tile.active })}
					onClick={tile.onClick}
					title={tile.active ? "Click to clear this filter" : "Click to filter the list"}
				>
					<div className="task-stat__label">
						<span className="task-stat__dot" />
						{tile.label}
					</div>
					<div className="task-stat__value">{typeof tile.value === "number" ? tile.value.toLocaleString() : tile.value}</div>
					<div className="task-stat__meta">{tile.meta}</div>
				</button>
			))}
		</div>
	);
};

export default TaskStats;
